import React from 'react'

const LoadingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12.265 21.3322C7.11818 21.3322 2.93164 17.1456 2.93164 11.9998C2.93164 6.85405 7.11818 2.6665 12.265 2.6665C17.4118 2.6665 21.5983 6.85304 21.5983 11.9998C21.5983 17.1466 17.4118 21.3332 12.265 21.3332V21.3322ZM12.265 5.67985C8.78054 5.67985 5.94499 8.5144 5.94499 11.9998C5.94499 15.4853 8.77954 18.3198 12.265 18.3198C15.7504 18.3198 18.585 15.4853 18.585 11.9998C18.585 8.5144 15.7504 5.67985 12.265 5.67985Z"
      fill="#D4DDEC"
    />
    <path
      d="M12.2651 21.3333V18.32C15.7496 18.32 18.5851 15.4854 18.5851 12H21.5985C21.5985 17.1458 17.4119 21.3333 12.2651 21.3333Z"
      fill="#0056AC"
    />
  </svg>
)

export default LoadingIcon

LoadingIcon.propTypes = {}
